import { SvgIcon } from '@mui/material';

const DeleteIcon = () => (
  <SvgIcon
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 25, height: 24, fill: 'none' }}
    data-testid="deleteIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 2C16.6046 2 17.5 2.89543 17.5 4V5H21C21.2761 5 21.5 5.22386 21.5 5.5V6.5C21.5 6.77614 21.2761 7 21 7H19.5V20C19.5 21.1046 18.6046 22 17.5 22H7.5C6.39543 22 5.5 21.1046 5.5 20V7H4C3.72386 7 3.5 6.77614 3.5 6.5V5.5C3.5 5.22386 3.72386 5 4 5H7.5V4C7.5 2.89543 8.39543 2 9.5 2H15.5ZM15 4C15.2761 4 15.5 4.22386 15.5 4.5V5H9.5V4.5C9.5 4.22386 9.72386 4 10 4H15ZM10.5 9C9.94772 9 9.5 9.44772 9.5 10V17C9.5 17.5523 9.94772 18 10.5 18C11.0523 18 11.5 17.5523 11.5 17V10C11.5 9.44772 11.0523 9 10.5 9ZM13.5 10C13.5 9.44772 13.9477 9 14.5 9C15.0523 9 15.5 9.44772 15.5 10V17C15.5 17.5523 15.0523 18 14.5 18C13.9477 18 13.5 17.5523 13.5 17V10Z"
      fill="#D52B1E"
    />
  </SvgIcon>
);

export default DeleteIcon;

export const DeleteIconSmall = () => (
  <SvgIcon
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 16, height: 16, fill: 'none' }}
    data-testid="deleteIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.33331C10.7364 1.33331 11.3333 1.93027 11.3333 2.66665V3.33331H13.6667C13.8508 3.33331 14 3.48255 14 3.66665V4.33331C14 4.51741 13.8508 4.66665 13.6667 4.66665H12.6667V13.3333C12.6667 14.0697 12.0697 14.6666 11.3333 14.6666H4.66667C3.93029 14.6666 3.33333 14.0697 3.33333 13.3333V4.66665H2.33333C2.14924 4.66665 2 4.51741 2 4.33331V3.66665C2 3.48255 2.14924 3.33331 2.33333 3.33331H4.66667V2.66665C4.66667 1.93027 5.26362 1.33331 6 1.33331H10ZM9.66667 2.66665C9.85076 2.66665 10 2.81588 10 2.99998V3.33331H6V2.99998C6 2.81588 6.14924 2.66665 6.33333 2.66665H9.66667ZM6.66667 5.99998C6.29848 5.99998 6 6.29846 6 6.66665V11.3333C6 11.7015 6.29848 12 6.66667 12C7.03486 12 7.33333 11.7015 7.33333 11.3333V6.66665C7.33333 6.29846 7.03486 5.99998 6.66667 5.99998ZM8.66667 6.66665C8.66667 6.29846 8.96514 5.99998 9.33333 5.99998C9.70152 5.99998 10 6.29846 10 6.66665V11.3333C10 11.7015 9.70152 12 9.33333 12C8.96514 12 8.66667 11.7015 8.66667 11.3333V6.66665Z"
      fill="#D52B1E"
    />
  </SvgIcon>
);
